"use client";

import { useTranslation } from "react-i18next";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { PAGES } from "@/internals/constants/pages";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

export interface UseEmptyDataResult {
  isInitialPreview: boolean;
  data: any;
  defaultPreviewTitle: string;
}

export const useEmptyData = (
  props: QRProps<any> & { data?: { defaultPreviewTitle?: string } }
): UseEmptyDataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);
  const { t } = useTranslation(PAGES.QR_EDITOR_LAYOUT);

  const defaultPreviewTitle = props.data?.defaultPreviewTitle || t("default_preview");

  return {
    isInitialPreview,
    data,
    defaultPreviewTitle,
  };
};
